module.exports = __webpack_public_path__ + "img/ballot-primary.2c800deb.svg";